import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import { SystemStatus } from 'types/SystemStatus/SystemStatus';

export function callApi(postObject: Request): Promise<Optional<string>> {
	const url = `${SERVICEBASEURL.BACKEND}/Menu`;
	return axios.post(url, postObject).toOptionalMapped((x) => x.data);
}

export interface Request {
	currencyCode: string | null;
	nameTranslations: Translation;
	recipes: string[];
	shortDescriptionTranslations: Translation;
	statusId: string | null;
	systemStatus: SystemStatus;
	tags: string[];
}

export interface Response {
	data: string;
}

export type Translation = {
	[key: string]: string;
};
